//#region import
import React, { useEffect, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Typography } from '@mui/material';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import { useLocation, useNavigate } from 'react-router';
import { Extension, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import SwitchFormItem from 'components/Input/Switch';
import { BtnBack, BtnCancel, BtnPreview, BtnSave } from 'components/Button/ButtonAll';
import UploadFile from 'components/Input/UploadFile';
import { DateRangePickerItem } from 'components/Input/DatePicker/DateRangePickerItem';
import { ICheckboxItem } from 'components/Input/Checkbox/CheckboxProps';
import { I18NextNs } from 'enum/enum';
import { CheckBoxItem } from 'components/Input/Checkbox/CheckBoxItem';
import _ from "lodash";
import TextOption from '../AdminBanner/TextOption/TextOption';
import moment from 'moment';
import { GetMenuPermission } from 'utilities/SystemFunction';
//#endregion

const GalleryForm = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/GallerySettingList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const [arrImportImg, setArrImportImg] = useState([]);
    const onClearImportFile = useRef(null);
    const [IsTextOption, setIsTextOption] = useState(false);
    const [IsShowPreview, setIsShowPreview] = useState<boolean>(false);
    const [previewData, setPreviewData] = useState({} as any);
    const [oldText, setOldText] = useState([]);
    const [prevData, setPrevData] = useState({} as any);
    const [DropdownTextPos, setDropdownTextPos] = useState([]);
    const [DropdownFontSize, setDropdownFontSize] = useState([]);
    const [DropdownLinkType, setDropdownLinkType] = useState([]);
    const [sPlacement, setsPlacement] = useState();
    const [arrTextOption, setArrTextOption] = useState([
        {
            nID: 1,
            sHeadline: "",
            sHeadlineFont: null,
            sHeadlineColor: null,
            sHeadlineSize: null,
            nTextOptionID: null,
            sTextMode: "N",
        },
    ] as any);
    const [FontColor, setFontColor] = useState([
        {
            displayColorPicker: false,
            defaultColor: "#999",
            changeColor: "#999",
            color:
            {
                r: "0",
                g: "9",
                b: "153",
                a: "1"
            }
        }]);

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            isActive: true,
            isPin: false,
        } as any,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const onSubmit = (e) => {
        let param = {
            sID: sID ?? "",
            sGalleryName: form.getValues("sGalleryName") ?? "",
            sDescription: form.getValues("sDescription") ?? "",
            fFile: arrImportImg ?? [],
            // fFileImg: arrImportImg2 ?? [],
            dStartDate: moment(form.getValues("dDateRange")[0]),
            dEndDate: moment(form.getValues("dDateRange")[1]),
            isPin: form.getValues("isPin"),
            isActive: form.getValues("isActive"),
            sTextOption: form.getValues("sTextOption"),
            lstHeadlineOption: arrTextOption,
            nPlacement: sPlacement,
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Gallery/SaveGallery`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate(`/GallerySettingList`);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const getDataInitial = () => {
        AxiosFn.Get(`Gallery/GetDataInitial`, {}, (result) => {
            setDropdownFontSize(result.lstFontSize);
            setDropdownTextPos(result.lstFontPosition);
            setDropdownLinkType(result.lstDisplayType);
        })
    }

    const getGalleryForm = (modeEqual) => {
        let oBannerCheck = {
            data: {},
            equal: false,
            preview: {},
        };
        let lstHeadlinePreview = [] as any;

        if (
            arrImportImg != null &&
            arrImportImg.length !== 0 &&
            IsTextOption
        ) {
            arrTextOption.forEach((item) => {
                let pdata = {
                    nID: item.nID,
                    sHeadline: form.getValues(`sHeadline_${item.nID}`),
                    // sHeadlineFont: DropdownFont.filter(
                    //     (f) => f.value === form.getValues(`sHeadlineFont_${item.nID}`)
                    // ).map((m) => m.sValue2)[0],
                    sHeadlineSize: DropdownFontSize.filter(
                        (f) => f.value === form.getValues(`sHeadlineSize_${item.nID}`)
                    ).map((m) => m.sValue2)[0],
                    // sHeadlineColor: DropdownFontColor.filter(
                    //     (f) => f.value === form.getValues(`sHeadlineColor_${item.nID}`)
                    // ).map((m) => m.sValue2)[0],
                };
                lstHeadlinePreview.push(pdata);
            });
        }

        let lstTextOption = arrTextOption;
        if (!modeEqual) {
            if (oldText != null && oldText.length > 0) {
                oldText.forEach((text, i) => {
                    if (
                        lstTextOption.find(
                            (f) => f.nTextOptionID === text.nTextOptionID
                        ) === undefined ||
                        lstTextOption.find((f) => f.nTextOptionID === text.nTextOptionID) ==
                        null
                    ) {
                        text.sTextMode = "D";
                        lstTextOption.push(text);
                    }
                });
            }
        }

        let dataFile = arrImportImg;

        let bannerForm = {
            sBannerName: form.getValues("sBannerName"),
            sDescription: form.getValues("sDescription"),
            // sSEOBannerName: form.getValues("sSEOBannerName"),
            // sSEODescription: form.getValues("sSEODescription"),
            // sTypeBanner: parseInt(form.getValues("sTypeBanner")),
            IsLink: form.getValues("IsLink"),
            sTextOption: form.getValues("sTextOption"),
            lstHeadlineOption: arrTextOption,
            // sPlacement: form.getValues("sPlacement"),
            // sTypeShow: form.getValues("sTypeShow"),
            sTypeLink: parseInt(form.getValues("sTypeLink")),
            sLink: form.getValues("sLink"),
            lstFile: dataFile,
            // sPin: form.getValues("sPin"),
            sStatus: form.getValues("sStatus"),
            //   objTimeData: objDate,
        };
        let previewData = {
            IsLink: form.getValues("IsLink"),
            sLink: form.getValues("sLink"),
            sTypeShow: DropdownLinkType.find(
                (f) => f.value === form.getValues("sTypeShow")
            )?.sValue2,
            sFileLink: (dataFile || []).map((file) => file.sFileLink)[0],
            sFileType: (dataFile || []).map((file) => file.sFileType)[0],
            lstHeadlineOption: lstHeadlinePreview,
            sPlacement: DropdownTextPos.find(
                (f) => f.value === form.getValues("sPlacement")
            )?.sValue2.replace(" ", ""),
        };
        oBannerCheck.data = bannerForm;
        oBannerCheck.preview = previewData;
        oBannerCheck.equal = _.isEqual(bannerForm, prevData);
        return oBannerCheck;
    };


    const DefaultDataPicture = () => {

        let data: ICheckboxItem[] = [
            {
                label: (arrImportImg || []).length === 0
                    ? I18n.SetText(`enableupload`, I18NextNs.translation) + "ข้อความบนภาพ"
                    : "เพิ่มข้อความบนภาพ", value: "1"
            }
        ];

        return data;

    };

    const onClearData = () => {
        form.setValue("sGalleryName", "");
        form.setValue("sDescription", "");
        form.setValue("dDateRange", [null, null]);
        form.setValue("isPin", false)
        form.setValue("isActive", true)
        form.clearErrors("sGalleryName");
        form.clearErrors("sDescription");
        form.clearErrors("dDateRange");
        form.clearErrors("isPin");
        form.clearErrors("isActive");
    };


    useEffect(() => {
        getDataInitial();
    }, [])

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <TextBoxItem
                            name="sGalleryName"
                            label='ชื่ออัลบัม'
                            maxLength={150}
                            id={"sGalleryName"}
                            required={true}
                            type={'text'}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextAreaItem
                            placeholder=""
                            label='รายละเอียด'
                            name="sDescription"
                            maxLength={200}
                            id={"sDescription"}
                            required={false}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography>
                            วันที่กิจกรรม
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item md={5} xs={12}>
                        <DateRangePickerItem
                            label={"วันที่กิจกรรม"}
                            labelStart={"วันที่เริ่มต้น"}
                            labelEnd={"วันที่สิ้นสุด"}
                            id={"dDateRange"}
                            name={"dDateRange"}
                            required={true}
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography>
                            ภาพปกอัลบัม
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <UploadFile
                            id="sGalleryFile"
                            name={"sGalleryFile"}
                            label={""}
                            required={false}
                            arrFile={arrImportImg}
                            setarrFile={setArrImportImg}
                            sFolderTemp="UserProfileImage"
                            IsFolder={false}
                            IsMultiple={false}
                            Extension={[...Extension.Image]}
                            nLimitFile={10}
                            sLimitFile={"MB"}
                            onClearFile={onClearImportFile}
                            sPositionText="right"
                            IsCrop={true}
                            cropRatio={16 / 9}
                            cropMovable={true}
                            cropResize={true}
                            cropShape='retangle'
                            modeDisplay='gallery'
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <CheckBoxItem
                                    name={'sTextOption'}
                                    disabled={(arrImportImg || []).length === 0 || !isPermission}
                                    id={'sTextOption'}
                                    required={false}
                                    onChange={(value) => {
                                        setIsTextOption(value);
                                    }}
                                    options={DefaultDataPicture()}

                                />
                            </Grid>
                            {(arrImportImg || []).length !== 0 ? (
                                <TextOption
                                    arrTextOption={arrTextOption}
                                    setArrTextOption={setArrTextOption}
                                    IsTextOption={IsTextOption}
                                    FontColor={FontColor}
                                    setFontColor={setFontColor}
                                    DropdownFontSize={DropdownFontSize}
                                    DropdownTextPos={DropdownTextPos}
                                    IsView={false}
                                    sPlacement={sPlacement}
                                    setsPlacement={setsPlacement}
                                    IsDisabled={!isPermission}
                                />
                            ) : null}
                        </Grid>
                    </Grid>
                    {/* <Grid item xs={12} md={12}>
                        <Typography>
                            เพิ่มรูปภาพ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid> */}
                    {/* <Grid item xs={12} md={12}>
                        <UploadFile
                            id="sGalleryFileTable"
                            name={"sGalleryFileTable"}
                            label={""}
                            required={false}
                            arrFile={arrImportImg2}
                            setarrFile={setArrImportImg2}
                            sFolderTemp="UserProfileImage"
                            IsFolder={false}
                            IsMultiple={true}
                            Extension={[...Extension.Image]}
                            nLimitFile={10}
                            sLimitFile={"MB"}
                            onClearFile={onClearImportFile}
                            sPositionText="right"
                            IsCrop={true}
                            cropRatio={16 / 9}
                            cropMovable={true}
                            cropResize={true}
                            cropShape='retangle'
                            modeDisplay='table'
                        />
                    </Grid> */}
                    <Grid item xs={12} md={12}>
                        <Typography>
                            ปักหมุด
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <SwitchFormItem
                            name={"isPin"}
                            checkText='ปักหมุด'
                            uncheckText='ไม่ปักหมุด'
                            disabled={!isPermission}
                            width={130}
                            id={"isPin"}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            disabled={!isPermission}
                            width={130}
                            id={"isActive"}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} sx={{ display: "flex", mt: 1.5 }} justifyContent={"space-between"}>
                    <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    <Grid sx={{ display: "flex" }}>
                        <BtnPreview
                            onClick={() => {
                                setPreviewData(getGalleryForm(false).preview);
                                setIsShowPreview(true);
                            }}
                            id={'btnpreview'}
                        />
                        <Grid sx={{ width: "10px" }}></Grid>
                        <BtnCancel
                            IsDisabled={!isPermission}
                            onClick={() => {
                                onClearData();
                            }}
                            id={'btncancel'}
                        />
                        <Grid sx={{ width: "10px" }}></Grid>
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

            </FormProvider>
        </React.Fragment >
    )
}


export default GalleryForm;